import { render, staticRenderFns } from "./VidiconCollect.vue?vue&type=template&id=11d9f300&scoped=true&"
import script from "./VidiconCollect.vue?vue&type=script&lang=js&"
export * from "./VidiconCollect.vue?vue&type=script&lang=js&"
import style0 from "./VidiconCollect.vue?vue&type=style&index=0&id=11d9f300&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d9f300",
  null
  
)

export default component.exports